import { useState, useEffect } from "react";
import { checkIsTablet } from "@helpers/is-tablet";

export const useIsTablet = (): boolean => {
  const [isTablet, setIsTablet] = useState<boolean>(checkIsTablet());

  useEffect(() => {
    const handleResize = () => {
      setIsTablet(checkIsTablet());
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return isTablet;
};
